module.exports = __webpack_public_path__ + "static/media/Novozymes-Tn.dc4c18ad.woff";